<template>
  <div class="p-x-20" :style="myStyle">
    <div class="d-flex-between-center container-cons">
      <div class="cons-logo">
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.5 7.5C15.5 11.6421 12.1421 15 8 15C3.85786 15 0.5 11.6421 0.5 7.5C0.5 3.35786 3.85786 0 8 0C12.1421 0 15.5 3.35786 15.5 7.5ZM8.83333 4.16664C8.83333 3.7064 8.46024 3.33331 8 3.33331C7.53976 3.33331 7.16667 3.7064 7.16667 4.16664V7.49997C7.16667 7.96021 7.53976 8.3333 8 8.3333C8.46024 8.3333 8.83333 7.96021 8.83333 7.49997V4.16664ZM8 10C7.53976 10 7.16667 10.3731 7.16667 10.8334C7.16667 11.2936 7.53976 11.6667 8 11.6667H8.008C8.46824 11.6667 8.84133 11.2936 8.84133 10.8334C8.84133 10.3731 8.46824 10 8.008 10H8Z"
            fill="#F2C94C"
          />
        </svg>
      </div>
      <div>
        <p class="m-d-0 f-c-black f-14 f-regular" v-html="title"></p>
        <p class="m-d-0 f-c-midgrey f-12 f-regular">
          <slot name="subtitle"> </slot>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SOInformation",
  props: {
    title: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      default: "Detail Maintenance",
    },
    myStyle: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.container-cons .cons-logo {
  margin-right: 8px;
}
.container-cons {
  padding: 12px 20px;
  background-color: #fff8e1;
  justify-content: unset;
}
</style>
